var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({staticClass:"nav-link",attrs:{"to":_vm.url}},'router-link',_vm.$attrs,false),[_c('div',{staticClass:"icon text-center d-flex align-items-center justify-content-center"},[_vm._t("icon")],2),_c('span',{staticClass:"nav-link-text ms-1"},[_vm._v(_vm._s(_vm.navText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }